import React from 'react';
import { useNavigate } from 'react-router-dom';
const CardAbout = ({ img, title, content }) => {
  const navigate = useNavigate();
  return (
    <div className="cardcustome p-2 cursor-pointer  ease-linear    ">
      <div className=" overflow-hidden cursor-pointer rounded-[17px]   ">
        <img
          className="object-cover w-full h-[350px] hover:scale-125  duration-300 ease-linear "
          src={img}
        ></img>
      </div>

      <div className="flex justify-start items-center pt-4 ">
        <p className=" text-primary_light line-clamp-2  text-[1.5rem]">
          {title}
        </p>
      </div>
      <div className="flex justify-center items-center ">
        <p
          className=" line-clamp-3 text-primary_light text-[1rem] pt-[0.5rem] mb-[1rem] opacity-80"
          style={{ fontWeight: 100, lineHeight: 1.6 }}
        >
          {content}
        </p>
      </div>
    </div>
  );
};

export default CardAbout;
